import { DatePipe } from '@angular/common';
import { Component, ViewContainerRef, inject, input, output } from '@angular/core';
import { ActionSheetComponent } from 'ngx-concern';
import { Event } from 'src/app/data/types';

@Component({
  selector: 'app-event-selection',
  templateUrl: './event-selection.component.html',
  styleUrls: ['./event-selection.component.scss'],
  imports: [DatePipe],
})
export class EventSelectionComponent {
  events = input.required<Event[]>();
  bottomRef = input.required<ActionSheetComponent>();
  selected = output<number>();
  ref = inject(ViewContainerRef);

  get refElement() {
    return this.ref.element.nativeElement as HTMLElement;
  }

  get actionListScrollTop() {
    return this.refElement.querySelector('div.list')?.scrollTop || 0;
  }

  close(index: number) {
    this.selected.emit(index);
    this.bottomRef().close();
  }
}
